import { queryOptions } from '@tanstack/react-query';
import { dashboardsApi } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

/**
 * Every dashboard the viewer can open, by name — the /dashboards index and the
 * title's switcher both read this, so they share ONE cache entry: a dashboard
 * created on the index is already in the switcher, and arriving from the index
 * opens the switcher with nothing to fetch.
 *
 * `scope: 'all'` partitions on the server — `mine` is ownership and `shared`
 * excludes it — so splitting the list by `owned` cannot double-count a
 * dashboard you own and also shared with everyone.
 *
 * 200 is the server's ceiling; callers compare `meta.total` against the rows
 * they got and say so when the list is cut off.
 */
const DASHBOARD_LIST = {
  scope: 'all',
  sortField: 'name',
  sortDirection: 'asc',
  limit: 200,
} as const;

export const dashboardListQuery = () =>
  queryOptions({
    queryKey: queryKeys.dashboards.list(DASHBOARD_LIST),
    queryFn: () => dashboardsApi.list(DASHBOARD_LIST),
  });
